module.exports = __webpack_public_path__ + "img/google-logo.4c55b8d3.png";